import React, { useState, useEffect } from 'react';
import {
    arrayOf,
    bool,
    node,
    number,
    oneOfType,
    shape,
    string,
} from 'prop-types';
import { connectRefinementList } from 'react-instantsearch-core';
import { useBaseUrls, useLocationSearchParams, useQuery } from 'hooks';
import { inCategorySearchShape } from 'shapes';
import { category as CategoryUtil } from 'utils';

import { Provider } from './Context';

const MAX_CATEGORY_PREVIEWS = 10;

const InCategorySearchPreviews = ({
    categoryPreviews: previews,
    children,
    items,
}) => {
    const baseUrls = useBaseUrls();
    const [query] = useQuery();
    const [selectedFilters] = useLocationSearchParams();

    const formatedPreviews = CategoryUtil.formatInCategorySearchData({
        data: previews,
        query,
        selectedFilters,
    });

    const [categoryPreviews, setCategoryPreviews] = useState(formatedPreviews);

    useEffect(() => {
        if (!categoryPreviews.length && items.length) {
            const trimmedIds = items
                .slice(0, MAX_CATEGORY_PREVIEWS)
                .map(item => item.label);
            CategoryUtil.fetchInCategorySearch(trimmedIds, {
                baseUrl: baseUrls.main,
            })()
                .then(data => {
                    const categoryPreviewsData = CategoryUtil.formatInCategorySearchData(
                        {
                            data,
                            query,
                            selectedFilters,
                        },
                    );
                    setCategoryPreviews(categoryPreviewsData);
                })
                .catch(err => {
                    console.warn(
                        `fail to fetch category previews informations (ids: ${trimmedIds})`,
                        err,
                    );
                });
        }
    }, []);

    return (
        <Provider
            value={{
                state: {
                    categoryPreviews,
                },
                actions: {},
            }}
        >
            {children}
        </Provider>
    );
};

InCategorySearchPreviews.propTypes = {
    categoryPreviews: inCategorySearchShape,
    children: node.isRequired,
    items: arrayOf(
        shape({
            count: number,
            isRefined: bool,
            label: string,
            value: oneOfType([string, arrayOf(string)]),
        }),
    ),
};
InCategorySearchPreviews.defaultProps = {
    categoryPreviews: [],
    items: [],
};

InCategorySearchPreviews.displayName = 'InCategorySearchPreviews';

export default connectRefinementList(InCategorySearchPreviews);
